// container.js
import React from 'react';
import MemberCardView from './view';

const MemberCard = (props) => {
  return <MemberCardView {...props} />;
};

export default MemberCard;